import { domContentLoadEvent } from '../common/domContentLoadEvent';

let timeoutList;

/**
 * VERSÃO MOBILE
 *
 * Funciona por clique, ao invés de hover (layout e comportamento mudam também)
 */
let breakpointMobile = 768;

function initializeMobile() {
    const level1Buttons = document.querySelectorAll('.level-1 .btn-level-1');
    level1Buttons.forEach((button) => {
        button.addEventListener('click', function (event) {
            mouseClickMobile(event, '.level-2');
        });
    });

    const level2Buttons = document.querySelectorAll('.level-2 .btn-level-2');
    level2Buttons.forEach((button) => {
        button.addEventListener('click', function (event) {
            mouseClickMobile(event, '.level-3');
        });
    });

    const level2BtnBack = document.querySelectorAll('.level-2 .btn-back');
    level2BtnBack.forEach(function (elemBtnBack) {
        elemBtnBack.addEventListener('click', mouseClickBackMobile);
    });
}

function mouseClickBackMobile(event) {
    if (window.outerWidth >= breakpointMobile) {
        return;
    }

    const elemBtnBack = event.target;

    event.preventDefault();
    event.stopImmediatePropagation();

    elemBtnBack.classList.remove('selected');

    const btnFilters = document.querySelectorAll('.btn-filter');
    btnFilters.forEach((elem) => {
        elem.classList.remove('selected');
    });
}

function mouseClickMobile(event, levelClass) {
    if (window.outerWidth >= breakpointMobile) {
        return;
    }

    const self = event.target;
    self.classList.add('selected');

    const siblings = getSiblings(self);
    siblings.forEach((sibling) => {
        sibling.classList.remove('selected');
    });
}

/**
 * VERSAO DESKTOP
 *
 * Delay para abertura e fechamento/refino de usabilidade.
 */
function initializeDesktop() {
    // Show level 2
    const level1Buttons = document.querySelectorAll('.level-1 .btn-level-1');
    level1Buttons.forEach((button) => {
        button.addEventListener('mouseenter', function (event) {
            mouseEnterLevelDesktop(event, '.level-2');
        });
        button.addEventListener('mouseleave', function (event) {
            mouseLeaveLevelDesktop(event, '.level-2');
        });
    });

    // Show level 3
    const level2Buttons = document.querySelectorAll('.level-2 .btn-level-2');
    level2Buttons.forEach((button) => {
        button.addEventListener('mouseenter', function (event) {
            mouseEnterLevelDesktop(event, '.level-3');
        });
        button.addEventListener('mouseleave', function (event) {
            mouseLeaveLevelDesktop(event, '.level-3');
        });
    });
}

function mouseEnterLevelDesktop(event, levelClass) {
    if (window.outerWidth < breakpointMobile) {
        return;
    }

    clearTimeout(timeoutList);

    const self = event.target;
    self.classList.add('selected');

    timeoutList = setTimeout(function () {
        const levelElements = document.querySelectorAll(levelClass);
        levelElements.forEach((element) => {
            element.classList.add('hidden');
        });

        const levelElementsWithinSelf = self.querySelectorAll(levelClass);
        levelElementsWithinSelf.forEach((element) => {
            element.classList.remove('hidden');
        });

        const siblings = getSiblings(self);
        siblings.forEach((sibling) => {
            sibling.classList.remove('selected');
        });

        self.classList.add('selected');
    }, 200);
}

function mouseLeaveLevelDesktop(event, levelClass) {
    if (window.outerWidth < breakpointMobile) {
        return;
    }

    clearTimeout(timeoutList);

    const self = event.target;
    self.classList.remove('selected');

    timeoutList = setTimeout(function () {
        const levelElementsWithinSelf = self.querySelectorAll(levelClass);
        levelElementsWithinSelf.forEach((element) => {
            element.classList.add('hidden');
        });
    }, 200);
}

// Helper function to get siblings of an element
function getSiblings(element) {
    const siblings = [];
    let sibling = element.parentNode.firstChild;

    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== element) {
            siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
    }

    return siblings;
}

domContentLoadEvent(initializeDesktop);
domContentLoadEvent(initializeMobile);
